(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coll-display2"]) return;
  try {
    
  $(document).ready(function(){
    $('#product-carousel-2').slick({
      slidesToShow: 3, // Adjust the number of slides to show at a time
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000 // Adjust the autoplay speed in milliseconds
    });
  });

  } catch(e) { console.error(e); }
})();
})();
